import { nanoid } from 'nanoid'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { Operation } from '@apollo/client/core'
import * as crypoto from '@/utils/crypto'
import storage, { StorageType } from '@/utils/storage'

dayjs.extend(utc)

interface Sign {
  'gh-nonce': string
  'gh-deviceid': string
  'gh-date': string
  'gh-token': string
  'gh-bodyhash': string
  'gh-appid': string
  'gh-sign': string
}

/**
 * 普通接口签名
 * @param operation
 * @returns
 */
export default function signWrap (operation?: Operation): Sign {
  let paramsBody = {}
  if (operation) {
    const { query, operationName, variables } = operation
    const queryBody = query.loc?.source.body
    paramsBody = {
      operationName,
      queryBody,
      variables
    }
  }
  const deviceIdIo: any = storage.rcGetItem(StorageType.local, 'deviceId') || ''
  const sessionId: any = storage.rcGetItem(StorageType.local, 'sessionId') || ''
  const token = sessionId && JSON.parse(sessionId)
  // const token = '124'
  const nonce = nanoid()
  const deviceid = deviceIdIo && JSON.parse(deviceIdIo)
  const date = dayjs
    .utc()
    .format()
    .replace(/(-|:)/g, '')
  const bodyHash = crypoto
    .sha256Encrypt(JSON.stringify(paramsBody))
    .toUpperCase()
  const appid = process.env.VUE_APP_H5_APPID || ''

  const signStr = `GH-DEVICEID:${deviceid},GH-TOKEN:${token},GH-DATE:${date},GH-NONCE:${nonce},GH-BODYHASH:${bodyHash},GH-APPID:${appid}`
  const signName = crypoto.hmacSha256Encrypt(signStr).toUpperCase()

  return {
    'gh-nonce': nonce,
    'gh-deviceid': deviceid,
    'gh-date': date,
    'gh-token': token,
    'gh-bodyhash': bodyHash,
    'gh-appid': appid,
    'gh-sign': signName
  }
}
